export const transformationTemplates = {
    carouselContainerVer1: 'BrandHeroBanner',
    extraBrandTileCarousel: 'brandTile',
    slotVariant1Ver1: 'heroBanner',
    carouselContainerVer1Home: 'heroBanner'
}